import join from 'lodash/join'

import { Props as AnswerProps } from '../..'

const MultipleChoice = ({ answer }: AnswerProps) => {
  if (!Array.isArray(answer)) {
    return <div>Nessuna risposta disponibile</div>
  }

  const answerOption = answer.map((a: { id: number; value: string }) => a.value)
  return <div>{join(answerOption, ', ')}</div>
}

export default MultipleChoice
